export default {
    CREATE_VIP_PACKAGE: {
        label: '新增',
        value:'CREATE_VIP_PACKAGE',
    },
    MODIFY_VIP_PACKAGE: {
        label: '修改',
        value: 'MODIFY_VIP_PACKAGE'
    },
    DELETE_VIP_PACKAGE: {
        label: '删除',
        value: 'DELETE_VIP_PACKAGE'
    },
};
